import { render, staticRenderFns } from "./CustomerCaseStudies.vue?vue&type=template&id=1ae6bdec&scoped=true"
import script from "./CustomerCaseStudies.vue?vue&type=script&lang=js"
export * from "./CustomerCaseStudies.vue?vue&type=script&lang=js"
import style0 from "./CustomerCaseStudies.vue?vue&type=style&index=0&id=1ae6bdec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae6bdec",
  null
  
)

export default component.exports